// src/components/Layout.js
import React, { useState } from "react"
import { useAuth0 } from "../services/auth"
import { StaticQuery, graphql } from 'gatsby';
import Helmet from 'react-helmet';

import '../assets/sass/main.scss';
import Footer from './Footer';
import TopNav from './TopNav';
import brandIcon from '../assets/img/website-icon.png';

const Layout = ({ children, fullMenu }) => {
  const { isAuthenticated, loading } = useAuth0();
  const [isPreloaded, setPreloaded] = React.useState(true);
  const [headerOpen, toggleHeader] = useState(false);

  React.useEffect(()=>{
    const timeoutId = setTimeout(() => {
      setPreloaded(false);
    }, 100);
    return ()=>clearTimeout(timeoutId);
  });

  const toggleSidebar = (toggle) => toggleHeader(toggle);

  if (loading) {
    return <div className="spinner"><img src={brandIcon} /></div>;
  }

  return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: 'description', content: 'Healify' },
                { name: 'keywords', content: 'mental health, therapy' },
              ]}
            >
              <html lang="en" className={headerOpen?"sidemenu-open": "sidemenu-closed"} />
                <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&amp;display=swap" rel="stylesheet" />
            </Helmet>
              <div className="wrapper">
                <div className="main">
                  <TopNav headerOpen={headerOpen} toggleSidebar={toggleSidebar} />
                  {children}
                  <Footer />
                </div>
              </div>
          </>
        )}
      />
  )
}

export default Layout
